import { render, staticRenderFns } from "./ControleCrm.vue?vue&type=template&id=3fb27acc&"
import script from "./ControleCrm.vue?vue&type=script&lang=js&"
export * from "./ControleCrm.vue?vue&type=script&lang=js&"
import style0 from "./ControleCrm.vue?vue&type=style&index=0&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports